enum BarcodeFields {
	OUTPUT = "output",
	PAGEMODE = "pagemode",
	PAGERANGE = "pagerange",
	CONTENT = "content",
	FORMAT = "format",
	MARGIN = "margin",
	ROTATION = "rotation",
	WIDTH = "width",
	HEIGHT = "height",
	QRCODE_CORRECTION = "qrcode_correction",
	AZTEC_CORRECTION = "aztec_correction",
	AZTEC_LAYER = "aztec_layer",
	DATAMATRIX_CORRECTION = "datamatrix_correction",
	DATAMATRIX_SHAPE = "datamatrix_shape",
	PDF417_CORRECTION = "pdf417_correction",
	PDF417_COMPACTION = "pdf417_compaction",
	PDF417_DIMENSIONS = "pdf417_dimensions",
	PDF417_COL_MIN = "pdf417_col_min",
	PDF417_COL_MAX = "pdf417_col_max",
	PDF417_ROW_MIN = "pdf417_row_min",
	PDF417_ROW_MAX = "pdf417_row_max",
	PREVIEW = "preview",
	SWISSQRCODE_CONTENT_FORMAT = "swissqrcode_content_format",
	SWISSQRCODE_DPI = "swissqrcode_dpi",
	SWISSQRCODE_LANGUAGE = "swissqrcode_language",
	SWISSQRCODE_SEPARATOR = "swissqrcode_separator",
	SWISSQRCODE_FORMAT = "swissqrcode_format",
	FILENAME = "filename",
	SWISSQRCODE_POSITION = "swissqrcode_position",
	UNIT = "unit"
}

export default BarcodeFields;